import React from 'react';
export function SiteFooter() {
  return <footer className="border-t border-brand-100 px-5 py-10 sm:px-8" data-id="element-71" data-mp="1dqrohw3lfk7t">
      <div className="mx-auto flex max-w-3xl flex-col gap-3 text-[12px] leading-relaxed text-neutral-500 sm:flex-row sm:items-center sm:justify-between" data-id="element-72" data-mp="3r9arjlvbfw2d">
        <p className="text-[13px] font-bold uppercase tracking-[0.2em] text-brand-700" data-id="element-73" data-mp="3hig2yaulkkdr">Rylte</p>
        <p className="max-w-[28rem] sm:text-right" data-id="element-74" data-mp="3hglpfhlnnujp">
          © 2026 Rylte. Results vary by dog and yard. This page is informational and is not
          veterinary or legal advice.
        </p>
      </div>
    </footer>;
}